import AsyncStorage from '@react-native-async-storage/async-storage';
import { addSentryBreadcrumb } from '../../shared/sentry/sentryUser';

const SYNC_DEVICE_ID_KEY = '@vuelto/sync_device_id';

let cachedDeviceId: string | null = null;

export async function getOrCreateSyncDeviceId(): Promise<string> {
  if (cachedDeviceId) return cachedDeviceId;

  try {
    const existing = await AsyncStorage.getItem(SYNC_DEVICE_ID_KEY);
    if (existing && existing.trim().length >= 8) {
      cachedDeviceId = existing.trim();
      return cachedDeviceId;
    }
  } catch (error) {
    // ignore read errors; generate a new id
    addSentryBreadcrumb('sync', 'AsyncStorage.getItem device-id failed', 'warning', { error: String(error) });
  }

  const next = crypto.randomUUID();
  cachedDeviceId = next;
  try {
    await AsyncStorage.setItem(SYNC_DEVICE_ID_KEY, next);
  } catch (error) {
    // keep in-memory id for this session
    addSentryBreadcrumb('sync', 'AsyncStorage.setItem device-id failed', 'warning', { error: String(error) });
  }
  return next;
}

export function resetSyncDeviceIdCacheForTests(): void {
  cachedDeviceId = null;
}
